import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import { useQuinceRouter as useRouter } from '@src/modules/navigation'

const useHash = (): [string, (node: string) => void] => {
  const [hash, setHash] = useState('')
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const updateHash = () => {
      const hash = window.location.hash
      const cleanHash = hash.includes('#') ? hash.split('#')[1] || '' : hash
      setHash(getCleanedHashWithoutSearchParams(cleanHash))
    }

    // Initial hash value
    updateHash()

    // Listen for hash change events
    window.addEventListener('hashchange', updateHash)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('hashchange', updateHash)
    }
  }, [pathname, searchParams])

  const setHashValue = (newHash: string) => {
    const safeHash = getSafeHashValue(newHash)
    router.push(safeHash)
  }

  return [hash, setHashValue]
}

function getSafeHashValue(hash: string) {
  if (hash.includes('#')) return hash
  else return `#${hash}`
}

export function getCleanedHashWithoutSearchParams(hash: string) {
  const cleanedHash = hash ? hash.split('?')[0] : ''
  if (cleanedHash?.includes('#')) return cleanedHash?.substring(1) ?? ''
  return cleanedHash ?? ''
}

export default useHash
